import React, { Component } from 'react'
import "../css/general-style.css"
import { confirmCloseAlert } from '../functions/alerts';
import { getIndexElement } from '../functions/searchInObject';
import { getInformationWithData, getInformationWithDataDashboard } from '../services/CABE';
import { getValueCookie } from '../services/cookieService';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from './LoadingWindow';
import ModalOrders from './ModalComponent';

export default class SearchItemName extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        items: [],
        showModal: false
    }

    onKeyDown = async e => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            await this.searchItemName(e.target.value)
            e.target.value = '';
        }
    }

    handleModalClose = () => {
        this.setState({ showModal: false, items: [] })
    }

    // Step 1: search items by name, results are shown in a selection modal
    async searchItemName(name) {
        await this.ModalLoading.current.showState(true);

        const data = {
            Name: name
        }

        const respuesta = await getInformationWithDataDashboard('/Items/getItemByName', data);

        if (respuesta.status.code === 1 && respuesta.data !== undefined && respuesta.data !== null && respuesta.data.length > 0) {
            await this.setState({ items: respuesta.data, showModal: true })
        } else {
            confirmCloseAlert('incorrect', 'The Item: ' + name + ' was not found, try with another one')
        }

        this.ModalLoading.current.showState(false);
    }

    // Step 2: user picks an item from the modal, load it on screen exactly like Catalogue2NoPrices.selectItem does
    async selectItem(item) {
        await this.ModalLoading.current.showState(true);

        const Father = this.props.Padre
        let priceLevel = this.props.priceLevel
        if (!priceLevel) {
            priceLevel = 1
        }

        const data = {
            company: getValueCookie('Company'),
            idCompany: Number(getValueCookie('CompanyId')),
            idcompany: Number(getValueCookie('CompanyId')),
            priceLevel: priceLevel
        }

        const result = await getInformationWithData('/Items/get', data);

        if (getValueCookie('CompanyId') === '6') {
            data.idcompany = 3
            data.idCompany = 3
            const InventM = await getInformationWithData('/Items/get', data)
            result.status.code = InventM.status.code
            for (const invItem of InventM.data) {
                const dupIndex = getIndexElement(result.data, 'itemCode', invItem.itemCode)
                if (dupIndex !== -1) {
                    await result.data.splice(dupIndex, 1)
                }
            }
            result.data = result.data.concat(InventM.data)
        }

        if (result.status.code === 1) {
            const index = getIndexElement(result.data, 'itemCode', item.itemCode)
            if (index !== -1) {
                result.data[index].isUpdateImg = result.data[index].itemURLImage ? true : false
                await Father.setState({ Product: result.data[index] })
                await Father.updateUPCInputs(true)
                this.handleModalClose()
            } else {
                confirmCloseAlert('incorrect', 'The Item: ' + item.itemCode + ' was not found, try with another one')
            }
        }

        this.ModalLoading.current.showState(false);
    }

    render() {
        const btnWidth = this.props.width ? `${this.props.width}%` : `100%`;

        return (
            <div className="input-group" style={{ width: btnWidth, marginBottom: 0 }}>
                <LoadingWindow ref={this.ModalLoading} />
                <input id={this.props.id ? this.props.id : uuidv4()} disabled={this.props.disabled ? true : false} type="text" autoComplete='off' placeholder='Search by item name...' className='form-control search-input' onKeyDown={this.onKeyDown} />
                <button className="btn btn-primary">Search</button>

                <ModalOrders title={"Select a product"} show={this.state.showModal} close={this.handleModalClose}>
                    <div className='row g-2'>
                        {this.state.items.map((producto, i) => {
                            const description = producto.completeDesc && producto.completeDesc !== 'null' ? producto.completeDesc : producto.abbreviatedDesc
                            return (
                                <div key={i} className='col-sm-12 col-md-6 col-lg-4'>
                                    <div style={{
                                        background: '#ffffff',
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '12px',
                                        padding: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                        height: '100%',
                                    }}>
                                        <img
                                            src={producto.itemURLImage || '/assets/notavailable.png'}
                                            alt={description}
                                            style={{
                                                width: '100%',
                                                height: '140px',
                                                objectFit: 'contain',
                                                borderRadius: '8px',
                                                background: '#F8FAFC',
                                                border: '1px solid #F1F5F9',
                                                padding: '4px',
                                            }}
                                        />
                                        <span style={{
                                            background: 'rgba(37,99,235,0.08)',
                                            color: '#1e40af',
                                            border: '1px solid #BFDBFE',
                                            borderRadius: '6px',
                                            padding: '2px 8px',
                                            fontSize: '0.72rem',
                                            fontWeight: 700,
                                            letterSpacing: '0.3px',
                                            alignSelf: 'flex-start',
                                        }}>
                                            {producto.itemCode}
                                        </span>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '0.875rem',
                                            color: '#0F172A',
                                            fontWeight: 500,
                                            lineHeight: 1.4,
                                            flex: 1,
                                            overflow: 'hidden',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                        }}>
                                            {description}
                                        </p>
                                        <button
                                            type="button"
                                            onClick={() => this.selectItem(producto)}
                                            style={{
                                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                border: 'none', borderRadius: '10px', color: 'white',
                                                padding: '0.5rem 1rem', fontWeight: 600, fontSize: '0.875rem',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Select
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </ModalOrders>
            </div>
        )
    }
}
